import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { Iconify } from './iconify.js';

export type EmptyContentProps = {
  title: string;
  description?: string;
  icon?: string;
  action?: ReactNode;
  sx?: SxProps<Theme>;
};

export function EmptyContent({
  title,
  description,
  icon = 'solar:inbox-line-duotone',
  action,
  sx,
}: EmptyContentProps) {
  return (
    <Box
      sx={[
        { p: 6, display: 'grid', placeItems: 'center', textAlign: 'center' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack spacing={1.5} alignItems="center">
        <Iconify icon={icon} width={56} sx={{ color: 'text.disabled' }} />
        <Typography variant="h6">{title}</Typography>
        {description && (
          <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 420 }}>
            {description}
          </Typography>
        )}
        {action}
      </Stack>
    </Box>
  );
}
